import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'

export default class Navigation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showMainMenu: false,
      href: undefined
    }

    this.toggleMenu = this.toggleMenu.bind(this)
    this.handleClickOutsideMenu = this.handleClickOutsideMenu.bind(this)
    this.handleClickOutsideMenuAndSelectCity = this.handleClickOutsideMenuAndSelectCity.bind(this)
  }

  toggleMenu() {
    this.setState(prevState => ({
      showMainMenu: !prevState.showMainMenu,
    }))
  }

  handleClickOutsideMenu() {
    this.setState({
      showMainMenu: false,
    })
  }

  handleClickOutsideMenuAndSelectCity(selectedCity) {
    if (selectedCity === this.props.selectedCity) {
      return
    }
    sessionStorage.setItem('selectedCity', selectedCity)
    this.props.setCity(selectedCity);
  }

  render() {
    const { showMainMenu, href } = this.state
    const { imgSrc, selectedCity } = this.props

    return (
      <Fragment>
        <div className="container">
          <nav className={`nav ${showMainMenu ? 'touched' : ''}`}>
            <figure className="logo mt20 mb20 block">
              <a href={`/${selectedCity}`} onClick={this.handleClickOutsideMenu}>
                <LazyLoad height={10} throttle={200}>
                  <img
                    src={imgSrc}
                    alt="Prywatny Żłobek Rudolf"
                    width="132"
                    height="63"
                  />
                </LazyLoad>
              </a>
            </figure>

            <div
              className="mobile mobile_menu_bar"
              onTouchEnd={this.toggleMenu}
            >
              <span className="mobile_menu_bar-text">
                MENU
              </span>
              <span className="mobile_menu_bar-button" />
            </div>
            <ul>
              <li>
                <a
                  href={`/${selectedCity}`}
                  style={{ color: '#3399cc' }}
                  onClick={this.handleClickOutsideMenu}
                >
                  Strona główna
                </a>
              </li>
              <li className="mobile_menu-with-child">
                <a
                  style={{ color: '#ff9933' }}
                  href={href}
                >
                  Dla rodziców
                </a>
                <ul>
                  <li>
                    <a
                      href="/cennik"
                      style={{ color: '#ff9933' }}
                      onClick={this.handleClickOutsideMenu}
                    >
                      Cennik
                    </a>
                  </li>
                  <li>
                    <a
                      href="/klauzula-informacyjna"
                      style={{ color: '#ff9933' }}
                      onClick={this.handleClickOutsideMenu}
                    >
                      Klauzula informacyjna
                    </a>
                  </li>
                  {/* <li>
                    <a
                      href="/dokumenty"
                      style={{ color: '#ff9933' }}
                      onClick={this.handleClickOutsideMenu}
                    >
                      Dokumenty
                    </a>
                  </li> */}
                </ul>
              </li>
              <li className="mobile_menu-with-child">
                <a
                  style={{ color: '#624dd6' }}
                  href={href}
                >
                  Zajęcia
                </a>
                <ul>
                  <li>
                    <a
                      href="/mali-kucharze"
                      style={{ color: '#624dd6' }}
                      onClick={this.handleClickOutsideMenu}
                    >
                      Mali Kucharze
                    </a>
                  </li>
                  <li>
                    <a
                      href="/plastyka"
                      style={{ color: '#624dd6' }}
                      onClick={this.handleClickOutsideMenu}
                    >
                      Plastyka
                    </a>
                  </li>
                  <li>
                    <a
                      href="/rytmika"
                      style={{ color: '#624dd6' }}
                      onClick={this.handleClickOutsideMenu}
                    >
                      Rytmika
                    </a>
                  </li>
                  <li>
                    <a
                      href="/sensoplastyka"
                      style={{ color: '#624dd6' }}
                      onClick={this.handleClickOutsideMenu}
                    >
                      Sensoplastyka
                    </a>
                  </li>
                  <li>
                    <a
                      href="/zabawy-na-powietrzu"
                      style={{ color: '#624dd6' }}
                      onClick={this.handleClickOutsideMenu}
                    >
                      Zabawy
                      na świeżym powietrzu

                    </a>
                  </li>
                </ul>
              </li>
              <li className="mobile_menu-with-child">
                <a
                  style={{ color: 'rgb(226, 54, 100)' }}
                  href={href}
                >
                  Nasze placówki
                </a>
                <ul>
                  <li>
                    <a
                    href={this.props.selectedCity === 'szczecin' ? null : '/szczecin'}
                      style={{
                        color: this.props.selectedCity === 'szczecin' ? 'rgba(165, 165, 165, 1) !important' : 'rgb(226, 54, 100)',
                        cursor:  this.props.selectedCity === 'szczecin' ? 'not-allowed' : 'pointer',
                      }}
                    >
                      SZCZECIN {this.props.selectedCity === 'szczecin' && ( <span> - aktualnie wybrana</span>)}
                    </a>
                  </li>
                  <li>
                    <a
                    href={this.props.selectedCity === 'pila' ? null : '/pila'}
                       style={{
                        color: this.props.selectedCity === 'pila' ? 'rgba(165, 165, 165, 1) !important' : 'rgb(226, 54, 100)',
                        cursor:  this.props.selectedCity === 'pila' ? 'not-allowed' : 'pointer',
                      }}
                    >
                      PIŁA {this.props.selectedCity === 'pila' && ( <span> - aktualnie wybrana</span>)}
                    </a>
                  </li>
                  <li>
                  </li>
                </ul>
              </li>
              {selectedCity === 'pila' && (
                <li >
                  <a
                    href="/pila/maluch-plus"
                    style={{ color: 'red' }}
                    onClick={this.handleClickOutsideMenu}
                  >
                    Maluch +
                  </a>
                </li>

              )}
              <li>
                <a
                  href="/kontakt"
                  style={{ color: '#999966' }}
                  onClick={this.handleClickOutsideMenu}
                >
                  Skontaktuj się
                </a>
              </li>
              

            </ul>
          </nav>
        </div>
      </Fragment>
    )
  }
}
Navigation.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  setCity: PropTypes.func.isRequired,
}
